import {useCallback, useEffect, useState} from "react";
import useHubContext from "./useHubContext";
import PeripheralService from "../services/PeripheralService";
import apiClient from "../auth/apiClient";
import * as c from "../constants";

const service = new PeripheralService(apiClient);

export const useDoor = (deviceID) => {
    const {portalHub} = useHubContext();

    const GetDoorData = useCallback(async () => {
        try {
            const result = await service.getPeripherals(deviceID);
            let doorData = result.data.find((x) => x.name.toLowerCase() === "doorstrike")?.settings;
            if (doorData === undefined) {
                return;
            }

            return doorData;
        } catch (error) {
            console.error(error);
        }
    }, [deviceID]);




     const sendDoorAction = async () =>{
         try {
             const doorStrikeIoData = await GetDoorData();
             if(!doorStrikeIoData){
                 return;
             }

             portalHub.invoke(c.PORTAL_TRIGGER_C2E, {
                 entityID: deviceID,
                 message: {
                     name: "DOOR_STRIKE",
                     payload: {
                         ioMappingID: doorStrikeIoData?.ioMappingID,
                         duration: parseInt(doorStrikeIoData?.vendStrikeDuration) ?? 0,
                     },
                 },
             });
         } catch (error) {
            console.error(error);
         }

     }

    return {
        sendDoorAction
    };
}